import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
    title: {
        marginTop: '40px',
        marginBottom: theme.spacing(3)
    },
    form: {
		width: '75%',
		marginBottom: theme.spacing(2),
        '& .MuiFormControl-root': {
            marginBottom: theme.spacing(1)
        },
		'& .MuiTypography-body1': {
			fontSize: '0.8rem',
		}
    },
    buttonContainer: {
        width: '100%'
    },
    button: {
        width: '75%',
        marginBottom: theme.spacing(1),
    },
	topic: {
        fontWeight: 'bold',
        fontStyle: 'italic'
    },
    identedText: {
        paddingLeft: theme.spacing(4)
    },
}));

export default styles;
